// extracted by mini-css-extract-plugin
module.exports = {"form":"FormSection_form__3PosU"};